import { render, staticRenderFns } from "./DocumentIcon.vue?vue&type=template&id=53b827a0&scoped=true"
import script from "./DocumentIcon.vue?vue&type=script&lang=js"
export * from "./DocumentIcon.vue?vue&type=script&lang=js"
import style0 from "./DocumentIcon.vue?vue&type=style&index=0&id=53b827a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b827a0",
  null
  
)

export default component.exports